import type { ClinicClock } from "@/lib/clinic-clock";
import { formatDate } from "@/lib/format-data";

/**
 * The day an appointment falls on, on its location's clock, as "Oct 9" —
 * or `null` when that day is today, for a heading that says "Today" instead.
 */
export function appointmentDayLabel(
  start: string | Date,
  clock: ClinicClock,
): string | null {
  if (clock.dayOf(start) === clock.today()) return null;
  return formatDate(start, {
    month: "short",
    day: "numeric",
    timeZone: clock.timeZone,
  });
}
